// LoadingContext.js
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [activeRequests, setActiveRequests] = useState(0);
  const isLoading = activeRequests > 0;

  const startLoading = useCallback(() => {
    setActiveRequests(prev => prev + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setActiveRequests(prev => Math.max(0, prev - 1));
  }, []);

  const value = useMemo(() => ({ isLoading, startLoading, stopLoading }), [
    isLoading, startLoading, stopLoading
  ]);

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {isLoading && <GlobalLoader />}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

const GlobalLoader = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      overflow: 'hidden',
      background: 'rgba(59, 130, 246, 0.18)',
      zIndex: 9999,
    }}
  >
    <div style={{
      width: '35%',
      height: '100%',
      background: 'linear-gradient(90deg, #2563eb, #06b6d4)',
      animation: 'loading-progress 1.1s ease-in-out infinite',
    }} />
    <style>{`
      @keyframes loading-progress {
        0% { transform: translateX(-110%); }
        100% { transform: translateX(320%); }
      }
    `}</style>
  </div>
);
